import { observer } from "mobx-react-lite";
import { useState } from "react";
import "./aboutus.css";
import { useTranslation } from "react-i18next";

const AboutUs = () => {
 const { t } = useTranslation();
 const [privacyOpen, setPrivacyOpen] = useState(false);
 const [termsOpen, setTermsOpen] = useState(false);
 const [responsibilityOpen, setResponsibilityOpen] = useState(false);

 return (
  <div className="p-2">
   <h2 className="about_main-title">{t("About us title")}</h2>
   <div>
    <h3
     className="about-info-item-title"
     onClick={() => setPrivacyOpen(!privacyOpen)}
    >
     <strong>{t("Privacy Policy")}</strong>{" "}
     <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      xmlns="http://www.w3.org/2000/svg"
     >
      <path
       fill-rule="evenodd"
       clip-rule="evenodd"
       d="M0.707 0V2.001H5.292L0 7.293L1.414 8.707L6.706 3.415V8H8.707V0H0.707Z"
      ></path>
     </svg>
    </h3>
    {privacyOpen ? (
     <div className="about-info-item-text">
      <div dangerouslySetInnerHTML={{ __html: t("Privacy Policy text") }}></div>
      <div
       className="about-info-close-modal"
       onClick={() => setPrivacyOpen(!privacyOpen)}
      >
       {t("close")}
      </div>
     </div>
    ) : (
     false
    )}
   </div>

   <div>
    <h3
     className="about-info-item-title"
     onClick={() => setTermsOpen(!termsOpen)}
    >
     <strong>{t("User Policy")}</strong>{" "}
     <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      xmlns="http://www.w3.org/2000/svg"
     >
      <path
       fill-rule="evenodd"
       clip-rule="evenodd"
       d="M0.707 0V2.001H5.292L0 7.293L1.414 8.707L6.706 3.415V8H8.707V0H0.707Z"
      ></path>
     </svg>
    </h3>
    {termsOpen ? (
     <div className="about-info-item-text">
      <div dangerouslySetInnerHTML={{ __html: t("User Policy text") }}></div>
      <div
       className="about-info-close-modal"
       onClick={() => setTermsOpen(!termsOpen)}
      >
       {t("close")}
      </div>
     </div>
    ) : (
     false
    )}
   </div>

   <div>
    <h3
     className="about-info-item-title"
     onClick={() => setResponsibilityOpen(!responsibilityOpen)}
    >
     <strong>{t("Booking")}</strong>{" "}
     <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      xmlns="http://www.w3.org/2000/svg"
     >
      <path
       fill-rule="evenodd"
       clip-rule="evenodd"
       d="M0.707 0V2.001H5.292L0 7.293L1.414 8.707L6.706 3.415V8H8.707V0H0.707Z"
      ></path>
     </svg>
    </h3>
    {responsibilityOpen ? (
     <div className="about-info-item-text">
      <div dangerouslySetInnerHTML={{ __html: t("Booking text") }}></div>

      <div
       className="about-info-close-modal"
       onClick={() => setResponsibilityOpen(!responsibilityOpen)}
      >
       {t("close")}
      </div>
     </div>
    ) : (
     false
    )}
   </div>

   <div>
    <h3 className="about_main-title">
     {t("Contact details")} <br />
     {t("About us email")} <br />
     {t("About us adress")} <br />
     {t("About us phone")}
    </h3>
   </div>
  </div>
 );
};
export default observer(AboutUs);
